import localizationService from "@state/services/localizationService";

export function copyTextToClipboard(
	copyValue: string,
	successMessage?: string
) {
	const textarea = document.createElement("textarea");
	textarea.value = copyValue;
	textarea.setAttribute("readonly", "");
	textarea.style.position = "absolute";
	textarea.style.left = "-9999px";

	document.body.appendChild(textarea);

	textarea.select();

	try {
		const isSuccess = document.execCommand("copy");

		if (isSuccess) {
			const message = successMessage || "COMMON.COPIED";
			App.state.rootStore.notificationStore.success(
				localizationService.t(message)
			);
		}
	} catch (err) {
		console.error("Copy error:", err);
	}

	document.body.removeChild(textarea);
}
